<template>
  <div class="home">
    <section v-if="isLoading" key="loading">
      <div class="loading-mask">
        <img src="../img/loading.gif" />
        <span>努力加载中…</span>
      </div>
    </section>
    <section class="wrapper flex-vertical flex-ai-c" key="main">
      <header class="broadcast flex-basic flex-ai-c">
        <div class="layer"></div>
        <swiper class="carousel" :options="swiperOptions">
          <swiper-slide v-for="item in userList" :key="item.name" class="carousel-li flex-basic flex-ai-c">
            <p>{{item.name}} {{item.content}}</p>
          </swiper-slide>
        </swiper>
      </header>
      <template v-if="iswrap">
        <div class="redWrap">
          <img src="../img/imgs/tp.gif" class="redWrap-gif" @click="openWrap()" />
        </div>
      </template>
      <template v-else>
        <div class="bg"></div>
        <!-- <div class="content flex-vertical flex-ai-c" :class="[showPassword?'inputBgs':'inputBg']"> -->
        <div class="content flex-vertical flex-ai-c inputBgs">
          <div class="input-box">
            <div class="input flex-vertical flex-ai-c">
              <input type="tel" placeholder="请输入手机号" v-model="phoneNum" />
            </div>
            <div class="input flex-basic flex-ai-c flex-jc-sb">
              <div class="input-short flex-vertical flex-ai-c">
                <input type="tel" placeholder="请输入验证码" maxlength="4" v-model="codeNum" />
              </div>
              <div class="get-code" @click="bindGetCode">{{sendCodeText}}</div>
            </div>
            <div v-if="showPassword" id="set_password" class="input flex-vertical flex-ai-c">
              <input type="text" placeholder="请设置登录密码" v-model="passwordNum" />
            </div>
          </div>
          <div class="captcha" id="captcha"></div>
          <div class="register-button" @click="bindSendCode"></div>
          <!-- <div v-else class="Download">
              <p class="Download-title1">奖励金已放入账号</p>
              <p  class="Download-title2">下载APP去使用</p>
              <div  class="Download-btn" @click="downloadKomoi">立即使用</div>
            </div> -->
          <!-- <div class="conter-xie" @click="xie">
              <img src="../img/imgs/true.png" />
              <span>同意《可萌用户协议》</span>
            </div> -->
          <!-- <div class="bottom-img"></div> -->
        </div>
      </template>
      <img src="../img/imgs/sy@2x.png" class="bg-foot1" />
      <div class="popup flex-vertical flex-ai-c" v-if="showPopup" @touchmove.prevent>
        <div class="popup-window" @click="downloadKomoi">
          <p class="official">10000金币奖励已放至账号<br />下载APP即可提现</p>
          <div class="download"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import {
    Toast
  } from 'mint-ui'
  import md5 from 'blueimp-md5'
  export default {
    components: {
      swiper,
      swiperSlide
    },
    data() {
      return {
        endTime: new Date().getTime() + 24 * 60 * 60 * 1000,
        obj: null,
        iswrap: true,
        isLoading: false,
        timer: true,
        countdown: 59,
        countDownSend: null,
        is_new: null,
        phoneNum: '',
        codeNum: '',
        passwordNum: '',
        sendCodeText: '获取验证码',
        canGetCode: true,
        showPassword: false,
        showPopup: false,
        validate:false,
        userList: [{
            name: 'babyqi',
            content: '获得10000金币'
          },
          {
            name: '心有执念',
            content: '获得10000金币'
          },
          {
            name: 'BOBO',
            content: '获得10000金币'
          },
          {
            name: '往事如风',
            content: '获得10000金币'
          },
          {
            name: '瑶',
            content: '获得10000金币'
          },
          {
            name: '阿雷',
            content: '获得10000金币'
          },
          {
            name: 'luizy',
            content: '获得10000金币'
          },
          {
            name: '爱走神',
            content: '获得10000金币'
          }
        ],
        swiperOptions: {
          loop: true,
          direction: 'vertical',
          allowTouchMove: false,
          autoplay: {
            delay: 2000,
          }
        }
      }
    },
    mounted() {
      window.NVC_Opt = {
        appkey: 'FFFF0N1N00000000994B',
        scene: 'nvc_register_h5',
        isH5: true,
        popUp: false,
        renderTo: '#captcha',
        nvcCallback: function(data) {
          const self = this;
          if (self.canGetCode) {
            if (!self.timer) {
              return
            }
            self.timer = false;
            let phoneNumber = self.phoneNum.trimX();
            if (/^1[0-9]{10}$/.test(phoneNumber)) {
              if (self.countdown == 59) {
                self.checkPhoneNum('86-' + phoneNumber, data);
              }
            } else {
              self.timer = true;
              Toast({
                message: '请输入正确的手机号',
                duration: 2000
              })
            }
          }
        },
        trans: {
          "key1": "code0",
          "nvcCode": 400
        },
        language: "cn",
        customWidth: 300,
        width: 300,
        height: 100,
        elements: [],
        bg_back_prepared: '',
        bg_front: '',
        obj_ok: '',
        bg_back_pass: '',
        obj_error: '',
        bg_back_fail: '',
        upLang: {
          "cn": {}
        }
      }

      var hm = document.createElement("script");
      hm.src = "//g.alicdn.com/sd/nvc/1.1.112/guide.js?t=" + new Date().getTime();
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    },
    created() {
      const self = this;
      String.prototype.trimX = function() {
        return this.replace(/[^\d]/gi, '');
      }
      //this.countDown();
    },
    methods: {
      openWrap() {
        this.iswrap = false;
      },
      timeFormat(param) {
        return param < 10 ? '0' + param : param;
      },
      countDown(it) {

        var interval = setInterval(() => {
          let newTime = new Date().getTime();
          let endTime = this.endTime;
          let obj = null;
          // 如果活动未结束，对时间进行处理
          if (endTime - newTime > 0) {
            let time = (endTime - newTime) / 1000;
            // 获取天、时、分、秒
            let day = parseInt(time / (60 * 60 * 24));
            let hou = parseInt(time % (60 * 60 * 24) / 3600);
            let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
            let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
            obj = {
              day: this.timeFormat(day),
              hou: this.timeFormat(hou),
              min: this.timeFormat(min),
              sec: this.timeFormat(sec)
            };
          } else { // 活动已结束，全部设置为'00'
            obj = {
              day: '00',
              hou: '00',
              min: '00',
              sec: '00'
            };
            clearInterval(interval);
          }
          this.obj = obj;
        }, 1000);
      },
      clickRule() {
        //open('http://k1-cdn.kemengjizhang.com/kemeng/mall/act/bounty_act/index.html#/Rule');
        this.$router.push('/Rule');
      },
      xie() {
        location.href = 'http://www.fenfenriji.com/help/term_mob.html';
      },
      downloadKomoi() {
        location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=net.kmjx.kmkj';
      },
      checkPhoneNum(num,data_Nvc) {
        const self = this;
        self.sendCodeText = '60S';
        self.canGetCode = false;
        self.countDownSend = setInterval(function() {
          self.setTime();
        }, 1000)
        var checkData;
        if (data_Nvc) {
          checkData = {
            data: data_Nvc
          };
        } else {
          checkData = {
            data: getNVCVal()
          };
        }
        self.sendPhoneNum({
          checkType: 'nvc',
          checkData: checkData,
          mobile: num,
          type: 1,
        }).then(res => {
          self.timer = true;
          if (res.data.result && res.data.result.data) {
            if (res.data.result.is_new || res.data.result.need_register) {
              self.showPassword = true;
              self.is_new = true;
            } else {
              self.is_new = false
            }
          } else {
            Toast({
              message: res.data.msg,
              duration: 2000
            })
            if (res.data.code == '15013') {
              self.validate = true;
              getNC().then(function() {
                _nvc_nc.upLang('cn', {
                  _startTEXT: "请按住滑块，拖动到最右边",
                  _yesTEXT: "验证通过",
                  _error300: "哎呀，出错了",
                  _errorNetwork: "网络不给力",
                })
                _nvc_nc.reset()
              })
            }
          }
        }).catch(e => {
          Toast({
            message: e.response.data.msg,
            duration: 2000
          })
        })
      },
      checkCode(phoneNumber, phoneCode, password) {
        const self = this;
        let invite_code = this.createUrl().code || '';
        let origin = this.createUrl().origin || 11;
				let channel = this.createUrl().channel || 1;
        self.sendCode({
          origin: origin,
          mobile: phoneNumber,
          invite_code: invite_code,
          verification_code: phoneCode,
          password: password ? md5(password) : ''
        },channel).then(res => {
          if (res.data.result) {
            if (self.is_new) {
              //self.$router.replace('/downloadApp');
              self.showPopup = true;
            } else {
              self.showPopup = true;
            }
          } else {
            Toast({
              message: res.data.msg,
              duration: 2000
            })
          }
        }).catch(e => {
          Toast({
            message: e.response.data.msg,
            duration: 2000
          })
        })
      },
      setTime: function() {
        const self = this;
        if (self.countdown == 0) {
          self.sendCodeText = "重新发送";
          clearInterval(self.countDownSend);
          self.countdown = 59;
          self.canGetCode = true;
        } else {
          self.sendCodeText = self.countdown + 'S';
          self.countdown -= 1;
        }
      },
      bindGetCode() {
        const self = this;
        if(self.validate){
          Toast({
            message:'请使用滑块验证',
            duration: 2000
          })
          return;
        }
        if (self.canGetCode) {
          if (!self.timer) {
            return
          }
          self.timer = false;
          console.log('成功发送')
          let phoneNumber = self.phoneNum.trimX();
          if (/^1[0-9]{10}$/.test(phoneNumber)) {
            if (self.countdown == 59) {
              self.checkPhoneNum('86-' + phoneNumber);
            }
          } else {
            self.timer = true;
            Toast({
              message: '请输入正确的手机号',
              duration: 2000
            })
          }
        }
      },
      bindSendCode() {
        const self = this;
        let phoneNumber = self.phoneNum.trimX();
        let code = self.codeNum.trimX();
        let password = self.passwordNum;
        if (self.is_new) {
          if (/^1[0-9]{10}$/.test(phoneNumber) && /\d{4}/.test(code) && password + '') {
            self.checkCode('86-' + phoneNumber, code, password);
          } else {
            if (password + '') {
              if (!/^1[0-9]{10}$/.test(phoneNumber) && !/\d{4}/.test(code)) {
                Toast({
                  message: '请输入正确的手机号和验证码',
                  duration: 2000
                })
              } else if (!/^1[0-9]{10}$/.test(phoneNumber)) {
                Toast({
                  message: '请输入正确的手机号',
                  duration: 2000
                })
              } else if (!/\d{4}/.test(code)) {
                Toast({
                  message: '请输入正确的验证码',
                  duration: 2000
                })
              }
            } else {
              Toast({
                message: '密码不能为空',
                duration: 2000
              })
            }
          }
        } else {
          if (/^1[0-9]{10}$/.test(phoneNumber) && /\d{4}/.test(code)) {
            self.checkCode('86-' + phoneNumber, code, '');
          } else {
            if (!/^1[0-9]{10}$/.test(phoneNumber) && !/\d{4}/.test(code)) {
              Toast({
                message: '请输入正确的手机号和验证码',
                duration: 2000
              })
            } else if (!/^1[0-9]{10}$/.test(phoneNumber)) {
              Toast({
                message: '请输入正确的手机号',
                duration: 2000
              })
            } else if (!/\d{4}/.test(code)) {
              Toast({
                message: '请输入正确的验证码',
                duration: 2000
              })
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped="">
  @import "../style/base";

  .home {
    flex: 1;
    background: linear-gradient(135deg, #FFAD1E 0%, #F94010 30%, #F82722 100%);
  }

  .captcha {
    width: 630px;
  }

  header {
    width: 100%;
    height: 64px;
    position: absolute;
    // position: absolute;
    // margin:0 auto;
    // top:0;
    // left:0;
    // text-align:center;
    top: 0;
    left: 0;
  }

  .rule {
    width: 104px;
    height: 56px;
    background-color: #FF0B65;
    position: absolute;
    top: 98px;
    right: 0;
    color: #FFFFFF;
    text-align: center;
    line-height: 56px;
    letter-spacing: 2px;
    font-size: 28px;
    border-top-left-radius: 36px;
    border-bottom-left-radius: 36px;
  }

  .redWrap {
    width: 750px;
    height: 1214px;
    background-image: url(../img/imgs/zw@2x.png);
    background-size: 750px 1214px;
    background-repeat: no-repeat;
    margin-bottom: 20px;

    .redWrap-gif {
      width: 244px;
      height: 246px;
      position: absolute;
      left: 266px;
      top: 578px;
    }
  }

  .bg-foot1 {
    width: 100%;
    margin: 0 auto;
  }

  .bg-foot2 {
    width: 100%;
  }

  .goods-li1 {
    width: 702px;
    height: 252px;
    background-image: url(../img/imgs/goods1@2x.png);
    background-size: 702px 252px;
    background-repeat: no-repeat;
    margin-top: 30px;
  }

  .goods-li2 {
    width: 702px;
    height: 252px;
    background-image: url(../img/imgs/goods2@2x.png);
    background-size: 702px 252px;
    background-repeat: no-repeat;
    margin-top: 30px;
  }

  .goods-li3 {
    width: 702px;
    height: 252px;
    background-image: url(../img/imgs/goods3@2x.png);
    background-size: 702px 252px;
    background-repeat: no-repeat;
    margin-top: 30px;
  }

  .goods {
    padding-bottom: 30px;
  }

  .wrapper {
    width: 100%;
    // min-height:1206px;
    box-sizing: border-box;

    // padding-top: 9px;
    .broadcast {
      width: 100%;
      text-align: center;
      z-index: 1;

      span {
        width: 34px;
        height: 24px;
        background-image: url(../img/broadcast.png);
        background-size: 34px 24px;
      }

      .layer {
        width: 100%;
        height: 64px;
        // background-color:rgba(200,200,200,0.2);
        background-image: url(../img/imgs/动态数据背景@3x.png);
        background-size: 750px 64px;
      }

      .carousel {
        width: 100%;
        overflow: hidden;
        // margin-left: 224px;
        height: 64px;
        position: absolute;
        left: 0;
        top: 0;

        .carousel-li {
          height: 64px;

          p {
            width: 100%;
            text-align: center;
            line-height: 64px;
            font-size: 24px;
            color: #FFFFFF;
          }
        }
      }
    }

    .bg {
      width: 750px;
      height: 700px;
      background-image: url(../img/imgs/success.png);
      background-size: 750px 700px;
      background-repeat: no-repeat;
      position: relative;

      p {
        width: 490px;
        height: 56px;
        position: absolute;
        left: 130px;
        top: 280px;
        color: #FFFFFF;
        font-size: 36px;
        text-align: center;
        line-height: 56px;
        font-weight: 500;
      }
    }


    .conter-xie {
      text-align: center;
      height: 32px;
      line-height: 32px;
      margin-bottom: 20px;
      padding-top: 10px;

      img {
        width: 32px;
        height: 32px;
        margin-right: 5px;
      }

      span {
        color: #ffffff;
        font-size: 24px;
      }
    }

    .inputBg {
      width: 100%;
      height: 470px;
      z-index: 1;
      background-image: url(../img/imgs/zhong.png);
      background-size: 750px 470px;
      background-repeat: no-repeat;
      margin-top: -1px;
    }

    .inputBgs {
      width: 100%;
      height: 590px;
      z-index: 1;
      background-image: url(../img/imgs/zhongs.png);
      background-size: 750px 590px;
      background-repeat: no-repeat;
      margin-top: -1px;
    }

    .content {
      text-align: center;
      border-radius: 16px;
      margin-top:-6px;
      // background-color: #ffffff;

      .Download {
        width: 750px;
        height: 400px;
        padding-top: 100px;
      }

      .Download-title1 {
        font-size: 40px;
        font-weight: 600;
        color: #ffffff;
      }

      .Download-title2 {
        font-size: 40px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 5px;
      }

      .Download-btn {
        width: 630px;
        height: 104px;
        background: linear-gradient(180deg, #FFEA0C 0%, #FFC10B 100%);
        margin-left: 60px;
        margin-top: 60px;
        border-radius: 52px;
        line-height: 104px;
        font-size: 44px;
        color: #FF5608;
      }

      input::-webkit-input-placeholder {
        color: #C4C0C0;
      }

      .input-box {
        margin-top: 10px;

        .input:first-child,
        .input:nth-child(3) {
          position: relative;
          margin-top: 11px;
          width: 590px;
          height: 111px;

          input {
            margin-top: 8px;
            box-sizing: border-box;
            width: 590px;
            height: 85px;
            border: none;
            background-color: #F2F4F7;
            padding: 0 36px;
            font-size: 30px;
            color: #333333;
            border-radius: 44px;
          }

          input::-webkit-input-placeholder {
            color: #a2a2a2;
          }
        }

        .input:nth-child(2) {
          position: relative;
          margin-top: 11px;
          width: 590px;
          height: 111px;

          .input-short {
            width: 328px;
            height: 111px;

            input {
              margin-top: 8px;
              box-sizing: border-box;
              width: 328px;
              height: 88px;
              border: none;
              background-color: transparent;
              font-size: 30px;
              padding: 36px;
              color: #333333;
              background-color: #F2F4F7;
              border-radius: 44px;
            }

            input::-webkit-input-placeholder {
              color: #C4C0C0;
            }
          }

          .get-code {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 100px;
            border: 2px solid #ffffff;
            width: 234px;
            height: 72px;
            /*margin-left: 24px;*/
            font-size: 32px;
            font-weight: 500;
            color: #ffffff;
            line-height: 72px;
          }
        }

        .input-long {
          background-image: url(../img/input_long.png);
          background-size: 470px 111px;
          background-repeat: no-repeat;
        }
      }

      .register-button {
        margin-top: 35px;
        width: 638px;
        height: 116px;
        background-image: url(../img/imgs/立即领取按钮@2x.png);
        background-size: 638px 116px;
        // position:absolute;
        // left:56px;
        // bottom:100px;
      }

      .bottom-img {
        margin-top: 178px;
        width: 750px;
        height: 1392px;
        background: url(../img/底部图@2x.jpg) center center no-repeat;
        background-size: 750px 1392px;
      }
    }

    .popup {
      position: fixed;
      z-index: 9;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.72);

      .popup-window {
        margin-top: 433px;
        width: 560px;
        height: 300px;
        border-radius: 16px;
        background-color: #FFFFFF;

        .official {
          color: #5C5050;
          font-size: 32px;
          text-align: center;
          margin-top: 46px;
        }

        .download {
          width: 370px;
          height: 76px;
          background: url(../img/imgs/立即下载按钮@2x.png) center center no-repeat;
          background-size: 370px 76px;
          margin: 0 auto;
          margin-top: 44px;
        }

      }
    }
  }

  .oldUser {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1206px;
    background-size: 750px auto;
    background-repeat: no-repeat;
    background-image: url(../img/bg.png);
  }

  .newUser {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1342px;
    background-size: 750px auto;
    background-repeat: no-repeat;
    background-image: url(../img/新用户-有注册密码@2x.jpg);
  }

  .mint-toast-text {
    font-size: 32px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue